import Cookies from 'js-cookie';
import { AUTH_COOKIE_NAME } from './config';

export const setAuthCookie = (token: string) => Cookies.set(AUTH_COOKIE_NAME, token);

export const getAuthCookie = () => Cookies.get(AUTH_COOKIE_NAME);

export const removeAuthCookie = () => Cookies.remove(AUTH_COOKIE_NAME);
